module.exports = __webpack_public_path__ + "static/media/1999.f0b42a56.svg";